module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-panel md-elevation-1 md-scrollbar md-theme-default",
    attrs: {
      "id": "itinerary"
    }
  }, [_c('div', {
    staticClass: "entity-card"
  }, [_c('div', {
    staticClass: "md-layout-row entity-card-head"
  }, [_c('div', {
    staticClass: "md-layout-item entity-head-left"
  }, [(_vm.$route.params.id) ? _c('span', [_vm._v(_vm._s('Маршрутный лист №' + _vm.$route.params.id))]) : _vm._e(), (_vm.result.status) ? _c('div', {
    staticClass: "status",
    style: ('color: ' + (_vm.result.status.color ? _vm.result.status.color : 'balck') + ';')
  }, [_vm._v(_vm._s(_vm.result.status.message))]) : _vm._e()]), _c('div', {
    staticClass: "md-layout-item entity-head-center"
  }), _c('div', {
    staticClass: "md-layout-item entity-head-right"
  }, [_c('md-button', {
    staticClass: "md-icon-button md-dense close small",
    on: {
      "click": _vm.back
    }
  }, [_c('md-icon', [_vm._v("close")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom",
      "md-delay": "500"
    }
  }, [_vm._v("Отменить")])], 1)], 1)]), _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "entity-card-body"
  }, [_c('div', {
    staticClass: "md-layout-item entity-head-tight"
  }, [_c('div', {
    staticClass: "md-body-1"
  }, [_c('div', {
    staticClass: "sum-data-title"
  }, [_vm._v("Суммарная информация по выбранным грузам")]), _c('div', {
    staticClass: "sum-data"
  }, [_c('div', {
    staticClass: "sum-data-item",
    attrs: {
      "md-with-hover": "md-with-hover"
    }
  }, [_c('span', [_vm._v(_vm._s('Вec (кг): '))]), _c('b', [_vm._v(_vm._s(parseFloat(_vm.result.weight).toFixed(2)))])]), _c('div', {
    staticClass: "sum-data-item",
    attrs: {
      "md-with-hover": "md-with-hover"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s('Объём (м<sup>3</sup>): ')
    }
  }), _c('b', [_vm._v(_vm._s(parseFloat(_vm.result.volume).toFixed(2)))])]), _c('div', {
    staticClass: "sum-data-item",
    attrs: {
      "md-with-hover": "md-with-hover"
    }
  }, [_c('span', [_vm._v(_vm._s('Мест: '))]), _c('b', [_vm._v(_vm._s(_vm.result.seats))])])]), _c('div', {
    staticClass: "direction-container"
  }, [_c('div', {
    staticClass: "direction-area__container"
  }, [_c('div', {
    staticClass: "direction-area"
  }, [_c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|integer'),
      expression: "'required|integer'"
    }],
    attrs: {
      "label": "Выберите тип перевозки",
      "required": true,
      "name": "forward_type",
      "id": "forward_type",
      "error": _vm.errors.first('forward_type'),
      "icon": "<i class=\"far fa-clipboard\"></i>",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.forward_type),
      callback: function($$v) {
        _vm.$set(_vm.result, "forward_type", $$v)
      },
      expression: "result.forward_type"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.value
      }
    })
  }))], 1), _c('div', {
    staticClass: "direction-area"
  }, [_c('z-big-date', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": ((parseInt(_vm.result.forward_type) === 1) ? 'Дата экспедирования' : 'Дата перевозки'),
      "required": true,
      "name": "date",
      "id": "date",
      "error": _vm.errors.first('date'),
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.date),
      callback: function($$v) {
        _vm.$set(_vm.result, "date", $$v)
      },
      expression: "result.date"
    }
  })], 1), (_vm.result && _vm.result.forward_type && parseInt(_vm.result.forward_type) === 2) ? _c('div', {
    staticClass: "direction-area"
  }, [(_vm.stocks && _vm.stocks.length) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|integer'),
      expression: "'required|integer'"
    }],
    attrs: {
      "label": "Склад отправления",
      "required": true,
      "name": "from_stock_id",
      "id": "from_stock_id",
      "error": _vm.errors.first('from_stock_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-warehouse\"></i>",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.from_stock_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "from_stock_id", $$v)
      },
      expression: "result.from_stock_id"
    }
  }, _vm._l((_vm.stocks), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  })) : _vm._e(), (_vm.responsiblesFrom && _vm.responsiblesFrom.length) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|integer'),
      expression: "'required|integer'"
    }],
    attrs: {
      "label": "Кладовщик в пункте отправления",
      "required": true,
      "name": "from_storekeeper_id",
      "id": "from_storekeeper_id",
      "error": _vm.errors.first('from_storekeeper_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-people-carry\"></i>",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.from_storekeeper_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "from_storekeeper_id", $$v)
      },
      expression: "result.from_storekeeper_id"
    }
  }, _vm._l((_vm.responsiblesFrom), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.login
      }
    })
  })) : _vm._e(), (_vm.result.from_stock_id && _vm.drivers && _vm.drivers.length) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|integer'),
      expression: "'required|integer'"
    }],
    attrs: {
      "label": "Водитель",
      "required": true,
      "name": "driver_id",
      "id": "driver_id",
      "error": _vm.errors.first('driver_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-truck\"></i>",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.driver_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "driver_id", $$v)
      },
      expression: "result.driver_id"
    }
  }, _vm._l((_vm.drivers), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  })) : _vm._e()], 1) : _vm._e(), (_vm.result && _vm.result.forward_type && parseInt(_vm.result.forward_type) === 2) ? _c('div', {
    staticClass: "direction-area"
  }, [(_vm.stocks && _vm.stocks.length) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|integer'),
      expression: "'required|integer'"
    }],
    attrs: {
      "label": "Склад назначения",
      "required": true,
      "name": "to_stock_id",
      "id": "to_stock_id",
      "error": _vm.errors.first('to_stock_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-warehouse\"></i>",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.to_stock_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "to_stock_id", $$v)
      },
      expression: "result.to_stock_id"
    }
  }, _vm._l((_vm.stocks), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  })) : _vm._e(), (_vm.responsiblesTo && _vm.responsiblesTo.length) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|integer'),
      expression: "'required|integer'"
    }],
    attrs: {
      "label": "Кладовщик в пункте назначения",
      "required": true,
      "name": "to_storekeeper_id",
      "id": "to_storekeeper_id",
      "error": _vm.errors.first('to_storekeeper_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-people-carry\"></i>",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.to_storekeeper_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "to_storekeeper_id", $$v)
      },
      expression: "result.to_storekeeper_id"
    }
  }, _vm._l((_vm.responsiblesTo), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.login
      }
    })
  })) : _vm._e(), (_vm.responsiblesTo && _vm.responsiblesTo.length) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|integer'),
      expression: "'required|integer'"
    }],
    attrs: {
      "label": "Ответственный за прием машины в пункте назначения",
      "required": true,
      "name": "to_chief_id",
      "id": "to_chief_id",
      "error": _vm.errors.first('to_chief_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-user-check\"></i>",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.to_chief_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "to_chief_id", $$v)
      },
      expression: "result.to_chief_id"
    }
  }, _vm._l((_vm.responsiblesTo), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.login
      }
    })
  })) : _vm._e()], 1) : _vm._e(), (_vm.result && _vm.result.forward_type && parseInt(_vm.result.forward_type) === 1) ? _c('div', {
    staticClass: "direction-area full-width"
  }, [(_vm.stocks && _vm.stocks.length) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|integer'),
      expression: "'required|integer'"
    }],
    attrs: {
      "label": "Склад экспедирования",
      "required": true,
      "name": "stock_id",
      "id": "stock_id",
      "error": _vm.errors.first('stock_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-warehouse\"></i>",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.stock_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "stock_id", $$v)
      },
      expression: "result.stock_id"
    }
  }, _vm._l((_vm.stocks), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  })) : _vm._e()], 1) : _vm._e(), (_vm.result && _vm.result.forward_type && parseInt(_vm.result.forward_type) === 1) ? _c('div', {
    staticClass: "direction-area"
  }, [(_vm.forwarders && _vm.forwarders.length) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|integer'),
      expression: "'required|integer'"
    }],
    attrs: {
      "label": "Ответственный экспедитор",
      "required": true,
      "name": "forwarder_id",
      "id": "forwarder_id",
      "data-vv-as": ' ',
      "error": _vm.errors.first('forwarder_id'),
      "icon": "<i class=\"fas fa-truck-loading\"></i>",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.forwarder_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "forwarder_id", $$v)
      },
      expression: "result.forwarder_id"
    }
  }, _vm._l((_vm.forwarders), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.login
      }
    })
  })) : _vm._e()], 1) : _vm._e(), (_vm.result && _vm.result.forward_type && parseInt(_vm.result.forward_type) === 1) ? _c('div', {
    staticClass: "direction-area"
  }, [(_vm.responsiblesFrom && _vm.responsiblesFrom.length) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|integer'),
      expression: "'required|integer'"
    }],
    attrs: {
      "label": "Ответственный кладовщик",
      "required": true,
      "name": "storekeeper_id",
      "id": "storekeeper_id",
      "error": _vm.errors.first('storekeeper_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-people-carry\"></i>",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.storekeeper_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "storekeeper_id", $$v)
      },
      expression: "result.storekeeper_id"
    }
  }, _vm._l((_vm.responsiblesFrom), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.login
      }
    })
  })) : _vm._e()], 1) : _vm._e()]), _c('div', {
    staticClass: "direction-area__container"
  }, [(_vm.vansAndTractors && _vm.vansAndTractors.length) ? _c('div', {
    staticClass: "direction-area"
  }, [_c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true
      }),
      expression: "{'required': true}"
    }],
    attrs: {
      "label": "Автомобиль",
      "required": true,
      "name": "auto_id",
      "id": "auto_id",
      "error": _vm.errors.first('auto_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-truck\"></i>",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.auto_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "auto_id", $$v)
      },
      expression: "result.auto_id"
    }
  }, _vm._l((_vm.vansAndTractors), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  }))], 1) : _vm._e(), (_vm.trailers && _vm.trailers.length) ? _c('div', {
    staticClass: "direction-area"
  }, [_c('z-big-multy-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true
      }),
      expression: "{'required': true}"
    }],
    attrs: {
      "label": "Прицеп",
      "required": true,
      "name": "trailers",
      "id": "trailers",
      "error": _vm.errors.first('trailers'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-trailer\"></i>",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.trailers),
      callback: function($$v) {
        _vm.$set(_vm.result, "trailers", $$v)
      },
      expression: "result.trailers"
    }
  }, _vm._l((_vm.trailers), function(item) {
    return _c('z-multy-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label,
        "selected": (_vm.result.trailers && (_vm.result.trailers.indexOf(item.id) + 1)) ? true : false
      }
    })
  }))], 1) : _vm._e(), (_vm.agents && _vm.agents.length) ? _c('div', {
    staticClass: "direction-area"
  }, [_c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true
      }),
      expression: "{'required': true}"
    }],
    attrs: {
      "label": "Агент (контрагент - исполнитель)",
      "required": true,
      "name": "agent_id",
      "id": "agent_id",
      "error": _vm.errors.first('agent_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-user-tie\"></i>",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.result.agent_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "agent_id", $$v)
      },
      expression: "result.agent_id"
    }
  }, _vm._l((_vm.agents), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  }))], 1) : _vm._e()])]), (!_vm.selectedFreights || !_vm.selectedFreights.length) ? _c('div', {
    staticClass: "freight-list-title error"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v("Грузы не выбраны")])]) : _vm._e(), (_vm.selectedFreights && _vm.selectedFreights.length) ? _c('div', {
    staticClass: "freight-list-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Выбранные грузы")]), (_vm.hasFreightsErrors) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("(В списке грузов есть ошибки. Проверьте список грузов.)")]) : _vm._e()]) : _vm._e(), (_vm.selectedFreights && _vm.selectedFreights.length) ? _c('div', {
    staticClass: "freight-list"
  }, _vm._l((_vm.selectedFreights), function(freight, i) {
    return _c('ZRLFreight', {
      key: ('zrl-' + i + '-' + freight.id),
      attrs: {
        "freight": freight,
        "error": (_vm.freightsErrors[freight.id]) ? _vm.freightsErrors[freight.id] : null,
        "show-remove": false,
        "storekeeper-view": true
      },
      on: {
        "remove": function($event) {
          _vm.removeFreight(freight)
        }
      }
    })
  })) : _vm._e()])])]), _c('div', {
    staticClass: "entity-card-footer"
  }, [_c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.$route.params.id && _vm.$route.params.id != 'new')),
      expression: "($route.params.id && $route.params.id != 'new')"
    }],
    staticClass: "md-primary small",
    on: {
      "click": _vm.printDoc
    }
  }, [_vm._v("Распечатать")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aa8c158","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/storekeepers_stocks/views/StorekeepersItinerary.vue
// module id = 1033
// module chunks = 0